import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';

const FONT_FAMILY = '"GT Walsheim Pro", "Open Sans", sans-serif';

export const InsightsDonutChart = ({ series = [], labels = [], colors = [], height = 200, chartRef }) => {
    const total = useMemo(() => series.reduce((sum, v) => sum + (v || 0), 0), [series]);

    const chartData = useMemo(
        () => labels.map((label, i) => ({ value: series[i] || 0, name: label, itemStyle: { color: colors[i] } })),
        [series, labels, colors]
    );

    const option = useMemo(
        () => ({
            tooltip: {
                trigger: 'item',
                formatter: (params) => {
                    return `<div style="padding:4px 2px;font-family:${FONT_FAMILY};font-size:12px;color:#344054;"><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${params.color};margin-right:6px;"></span>${params.name}: <b>${params.value}</b></div>`;
                },
                textStyle: { fontFamily: FONT_FAMILY, fontSize: 13 },
                extraCssText: 'padding:0; border:none; box-shadow:0 0 6px 0 rgba(138, 138, 138, 0.24); border-radius:8px;',
            },
            legend: { show: false },
            series: [
                {
                    type: 'pie',
                    radius: ['55%', '80%'],
                    center: ['50%', '50%'],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderColor: '#fff',
                        borderWidth: 2,
                        borderRadius: 4,
                    },
                    label: {
                        show: false,
                    },
                    emphasis: {
                        label: {
                            show: false,
                        },
                        itemStyle: {
                            shadowBlur: 6,
                            shadowColor: 'rgba(0,0,0,0.12)',
                        },
                    },
                    labelLine: { show: false },
                    data: chartData,
                },
            ],
            graphic: [
                {
                    type: 'text',
                    left: 'center',
                    top: '41%',
                    silent: true,
                    style: {
                        text: `${total}`,
                        textAlign: 'center',
                        fill: '#1D2939',
                        fontSize: 22,
                        fontWeight: 700,
                        fontFamily: FONT_FAMILY,
                    },
                },
                {
                    type: 'text',
                    left: 'center',
                    top: '53%',
                    silent: true,
                    style: {
                        text: 'Total',
                        textAlign: 'center',
                        fill: '#667085',
                        fontSize: 12,
                        fontWeight: 500,
                        fontFamily: FONT_FAMILY,
                    },
                },
            ],
        }),
        [chartData, total]
    );

    if (!series?.length || total === 0) return null;

    return <ReactECharts ref={chartRef} option={option} notMerge={true} style={{ height, width: '100%' }} opts={{ renderer: 'canvas' }} />;
};
